import React, { useContext } from 'react';
import styled from 'styled-components';
import AppRouter from '../router/AppRouter';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useLocalStorage } from '../../hooks/providers/useLocalStorage';
import UserContext from '../../context/user/UserContext';
import ThemeOptionContext from '../../context/theme-option/ThemeOptionContext';
import { IconButton, Tooltip } from '@mui/material';

const ContentStyled = styled.div`
  flex: 1;
  width: 100%;
  height: 100vh;
  overflow: auto;
  position: relative;
`;

const ToggleTheme = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
`;

const Content = () => {
  const { state: userState } = useContext(UserContext);
  const localStorage = useLocalStorage();
  const toggleTheme = () => {
    localStorage.setItem('isDark', !themeState.isDark);
    setThemeState(state => {
      return {
        ...state,
        isDark: !state.isDark,
      };
    });
  };

  const { state: themeState, setState: setThemeState } = useContext(ThemeOptionContext);
  return (
    <ContentStyled>
      {!userState.logged && (
        <ToggleTheme>
          {!themeState.isDark ? (
            <Tooltip title="Alterar tema para escuro">
              <IconButton onClick={() => toggleTheme()} size="small">
                <DarkModeIcon style={{ width: '15px' }} />
              </IconButton>
            </Tooltip>
          ) : (
            <Tooltip title="Alterar tema para claro">
              <IconButton onClick={() => toggleTheme()} size="small">
                <LightModeIcon style={{ width: '15px' }} />
              </IconButton>
            </Tooltip>
          )}
        </ToggleTheme>
      )}

      <AppRouter />
    </ContentStyled>
  );
};

export default Content;
